import React, { useState } from 'react';
import axios from 'axios';
import '../style.css';
import { contactUsAPI } from '../utils/Api'


const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    service: 'demo',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');
    setSubmitSuccess(false);

    try {
      // Call the API using axios POST request
      const response = await axios.post(contactUsAPI, formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      console.log('Form submitted successfully:', response.data);
      
      // Show success state
      setSubmitSuccess(true);
      
      // Reset form after 3 seconds
      setTimeout(() => {
        setFormData({
          name: '',
          email: '',
          company: '',
          phone: '',
          service: 'demo',
          message: ''
        });
        setSubmitSuccess(false);
      }, 3000);
      
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitError(
        error.response?.data?.message || 
        'Something went wrong. Please try again or contact us directly at contact@ivaluegroup.com'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Responsive helpers
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 700;
  const isTablet = typeof window !== 'undefined' && window.innerWidth <= 1024;

  return (
    <div style={{ minHeight: '100vh', background: '#ffffff' }}>
      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #0a2240 0%, #1e3a5f 100%)',
        padding: '120px 0 80px',
        color: 'white',
        textAlign: 'center'
      }}>
        <div className="container" style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 40px' }}>
          <h1 style={{
            fontSize: '3.5rem',
            fontWeight: 700,
            marginBottom: '24px',
            background: 'linear-gradient(90deg, #00b4a0 0%, #1e90ff 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            letterSpacing: '-0.5px'
          }}>
            Contact Us
          </h1>
          <p style={{
            fontSize: '1.3rem',
            maxWidth: '750px',
            margin: '0 auto',
            opacity: 0.95,
            lineHeight: 1.7,
            fontWeight: 400
          }}>
            iValue Group for Confluent center of excellence. Request a demo or consultation today.
          </p>
        </div>
      </section>

      {/* Main Content Section */}
      <section style={{ padding: isMobile ? '32px 0' : '100px 0', background: '#f8fafc' }}>
        <div className="container" style={{ maxWidth: '1400px', margin: '0 auto', padding: isMobile ? '0 8px' : '0 40px' }}>
          <div
            style={{
              display: isMobile ? 'block' : isTablet ? 'flex' : 'grid',
              flexDirection: isTablet ? 'column' : undefined,
              gridTemplateColumns: isMobile ? undefined : isTablet ? undefined : '500px 1fr',
              gap: isMobile ? 24 : isTablet ? 40 : 80,
              alignItems: 'start',
            }}
          >
            
            {/* Left Column - Company Info & CoE Details */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: isMobile ? 16 : 30,
              marginBottom: isMobile ? 24 : 0,
              width: '100%',
              maxWidth: isMobile ? '100%' : 500,
              margin: isMobile ? '0 auto 24px' : undefined,
            }}>
              

              {/* Confluent CoE Card */}
              <div style={{
                background: 'white',
                padding: isMobile ? '20px 10px' : '45px',
                borderRadius: isMobile ? 14 : 24,
                boxShadow: isMobile ? '0 4px 16px rgba(0,0,0,0.06)' : '0 20px 60px rgba(0,0,0,0.08)',
                border: '1px solid #e2e8f0',
                width: '100%',
                maxWidth: isMobile ? '100%' : 500,
                margin: isMobile ? '0 auto' : undefined,
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 10 : 18, marginBottom: isMobile ? 16 : 30 }}>
                  <div style={{
                    width: isMobile ? 38 : 68,
                    height: isMobile ? 38 : 68,
                    borderRadius: isMobile ? 8 : 16,
                    background: 'linear-gradient(135deg, #00b4a0 0%, #1e90ff 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: isMobile ? '1.2rem' : '2.2rem',
                    flexShrink: 0,
                    boxShadow: isMobile ? '0 2px 6px rgba(0,180,160,0.18)' : '0 8px 24px rgba(0,180,160,0.25)'
                  }}>🎯</div>
                  <h2 style={{
                    fontSize: isMobile ? '1.1rem' : '2rem',
                    fontWeight: 700,
                    color: '#1e293b',
                    margin: 0,
                    letterSpacing: '-0.5px'
                  }}>
                    Confluent CoE
                  </h2>
                </div>
                
                <p style={{
                  fontSize: isMobile ? '0.95rem' : '1.05rem',
                  color: '#64748b',
                  lineHeight: 1.6,
                  marginBottom: isMobile ? 12 : 30,
                  fontWeight: 400
                }}>
                  Our <strong style={{ color: '#1e293b' }}>Center of Excellence (CoE)</strong> for Confluent brings together certified experts, 
                  proven methodologies, and best practices to accelerate your data streaming journey.
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? 8 : 18 }}>
                  <div style={{
                    padding: isMobile ? '10px 8px' : '20px 22px',
                    background: 'linear-gradient(90deg, rgba(0,180,160,0.06) 0%, rgba(30,144,255,0.06) 100%)',
                    borderRadius: isMobile ? 6 : 12,
                    borderLeft: '4px solid #00b4a0',
                    transition: 'all 0.3s ease'
                  }}>
                    <h4 style={{ margin: isMobile ? '0 0 4px 0' : '0 0 10px 0', color: '#1e293b', fontSize: isMobile ? '0.98rem' : '1.08rem', fontWeight: 600, letterSpacing: '0.2px' }}>
                      🏆 Expert Team
                    </h4>
                    <p style={{ margin: 0, color: '#64748b', fontSize: isMobile ? '0.91rem' : '0.96rem', lineHeight: 1.5 }}>
                      Confluent-certified architects and engineers with 50+ successful implementations
                    </p>
                  </div>

                  <div style={{
                    padding: '20px 22px',
                    background: 'linear-gradient(90deg, rgba(0,180,160,0.06) 0%, rgba(30,144,255,0.06) 100%)',
                    borderRadius: '12px',
                    borderLeft: '4px solid #00b4a0',
                    transition: 'all 0.3s ease'
                  }}>
                    <h4 style={{ margin: '0 0 10px 0', color: '#1e293b', fontSize: '1.08rem', fontWeight: 600, letterSpacing: '0.2px' }}>
                      🔒 Security First
                    </h4>
                    <p style={{ margin: 0, color: '#64748b', fontSize: '0.96rem', lineHeight: 1.65 }}>
                      Enterprise-grade security architecture and compliance expertise
                    </p>
                  </div>

                  <div style={{
                    padding: '20px 22px',
                    background: 'linear-gradient(90deg, rgba(0,180,160,0.06) 0%, rgba(30,144,255,0.06) 100%)',
                    borderRadius: '12px',
                    borderLeft: '4px solid #1e90ff',
                    transition: 'all 0.3s ease'
                  }}>
                    <h4 style={{ margin: '0 0 10px 0', color: '#1e293b', fontSize: '1.08rem', fontWeight: 600, letterSpacing: '0.2px' }}>
                      📊 Best Practices
                    </h4>
                    <p style={{ margin: 0, color: '#64748b', fontSize: '0.96rem', lineHeight: 1.65 }}>
                      Industry-leading patterns and standards for data streaming excellence
                    </p>
                  </div>

                  <div style={{
                    padding: '20px 22px',
                    background: 'linear-gradient(90deg, rgba(0,180,160,0.06) 0%, rgba(30,144,255,0.06) 100%)',
                    borderRadius: '12px',
                    borderLeft: '4px solid #00b4a0',
                    transition: 'all 0.3s ease'
                  }}>
                    <h4 style={{ margin: '0 0 10px 0', color: '#1e293b', fontSize: '1.08rem', fontWeight: 600, letterSpacing: '0.2px' }}>
                      🤝 24/7 Support
                    </h4>
                    <p style={{ margin: 0, color: '#64748b', fontSize: '0.96rem', lineHeight: 1.65 }}>
                      Continuous monitoring, optimization, and dedicated support team
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Contact Form */}
            <div style={{
              background: 'white',
              padding: isMobile ? '20px 10px' : '50px',
              borderRadius: isMobile ? 12 : 20,
              boxShadow: isMobile ? '0 2px 8px rgba(0,0,0,0.08)' : '0 10px 40px rgba(0,0,0,0.1)',
              border: '1px solid #e2e8f0',
              height: 'fit-content',
              width: '100%',
              maxWidth: isMobile ? '100%' : 500,
              margin: isMobile ? '0 auto' : undefined,
            }}>
              <h2 style={{
                fontSize: isMobile ? '1.2rem' : '2rem',
                fontWeight: 700,
                color: '#1e293b',
                marginBottom: isMobile ? 6 : 10
              }}>
                Request Demo / Consultation
              </h2>
              <p style={{
                color: '#64748b',
                marginBottom: isMobile ? 18 : 35,
                fontSize: isMobile ? '0.97rem' : '1rem',
                lineHeight: 1.5
              }}>
                Fill out the form below and our experts will get back to you within 24 hours.
              </p>

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: isMobile ? 12 : 20 }}>
                <div>
                  <label style={{
                    display: 'block',
                    marginBottom: '8px',
                    color: '#1e293b',
                    fontWeight: 600,
                    fontSize: '0.95rem'
                  }}>
                    Full Name *
                  </label>
                  <input
                    type="text"
                    name="name"
                    placeholder="John Doe"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '14px 16px',
                      border: '2px solid #e2e8f0',
                      borderRadius: '10px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      fontFamily: 'inherit',
                      boxSizing: 'border-box'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#00b4a0';
                      e.target.style.boxShadow = '0 0 0 3px rgba(0,180,160,0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e2e8f0';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <div>
                  <label style={{
                    display: 'block',
                    marginBottom: '8px',
                    color: '#1e293b',
                    fontWeight: 600,
                    fontSize: '0.95rem'
                  }}>
                    Email Address *
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="john@company.com"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '14px 16px',
                      border: '2px solid #e2e8f0',
                      borderRadius: '10px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      fontFamily: 'inherit',
                      boxSizing: 'border-box'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#00b4a0';
                      e.target.style.boxShadow = '0 0 0 3px rgba(0,180,160,0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e2e8f0';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <div style={{ display: isMobile ? 'block' : 'grid', gridTemplateColumns: isMobile ? undefined : '1fr 1fr', gap: isMobile ? 8 : 15 }}>
                  <div>
                    <label style={{
                      display: 'block',
                      marginBottom: '8px',
                      color: '#1e293b',
                      fontWeight: 600,
                      fontSize: '0.95rem'
                    }}>
                      Company
                    </label>
                    <input
                      type="text"
                      name="company"
                      placeholder="Company Name"
                      value={formData.company}
                      onChange={handleInputChange}
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: '2px solid #e2e8f0',
                        borderRadius: '10px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        fontFamily: 'inherit',
                        boxSizing: 'border-box'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#00b4a0';
                        e.target.style.boxShadow = '0 0 0 3px rgba(0,180,160,0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e2e8f0';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>

                  <div>
                    <label style={{
                      display: 'block',
                      marginBottom: '8px',
                      color: '#1e293b',
                      fontWeight: 600,
                      fontSize: '0.95rem'
                    }}>
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="+1 (555) 000-0000"
                      value={formData.phone}
                      onChange={handleInputChange}
                      style={{
                        width: '100%',
                        padding: '14px 16px',
                        border: '2px solid #e2e8f0',
                        borderRadius: '10px',
                        fontSize: '1rem',
                        transition: 'all 0.3s ease',
                        fontFamily: 'inherit',
                        boxSizing: 'border-box'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = '#00b4a0';
                        e.target.style.boxShadow = '0 0 0 3px rgba(0,180,160,0.1)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = '#e2e8f0';
                        e.target.style.boxShadow = 'none';
                      }}
                    />
                  </div>
                </div>

                <div>
                  <label style={{
                    display: 'block',
                    marginBottom: '8px',
                    color: '#1e293b',
                    fontWeight: 600,
                    fontSize: '0.95rem'
                  }}>
                    I'm interested in *
                  </label>
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '14px 16px',
                      border: '2px solid #e2e8f0',
                      borderRadius: '10px',
                      fontSize: '1rem',
                      transition: 'all 0.3s ease',
                      fontFamily: 'inherit',
                      background: 'white',
                      cursor: 'pointer',
                      boxSizing: 'border-box'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#00b4a0';
                      e.target.style.boxShadow = '0 0 0 3px rgba(0,180,160,0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e2e8f0';
                      e.target.style.boxShadow = 'none';
                    }}
                  >
                    <option value="demo">Request a Demo</option>
                    <option value="consultation">Free Consultation</option>
                    <option value="implementation">Confluent Implementation</option>
                    <option value="migration">Data Migration Services</option>
                    <option value="training">Training & Enablement</option>
                    <option value="support">Managed Support</option>
                    <option value="optimization">Performance Optimization</option>
                    <option value="other">General Inquiry</option>
                  </select>
                </div>

                <div>
                  <label style={{
                    display: 'block',
                    marginBottom: '8px',
                    color: '#1e293b',
                    fontWeight: 600,
                    fontSize: '0.95rem'
                  }}>
                    Message *
                  </label>
                  <textarea
                    name="message"
                    placeholder="Tell us about your requirements, challenges, or questions..."
                    rows="6"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '14px 16px',
                      border: '2px solid #e2e8f0',
                      borderRadius: '10px',
                      fontSize: '1rem',
                      resize: 'vertical',
                      fontFamily: 'inherit',
                      transition: 'all 0.3s ease',
                      boxSizing: 'border-box'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#00b4a0';
                      e.target.style.boxShadow = '0 0 0 3px rgba(0,180,160,0.1)';
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#e2e8f0';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting || submitSuccess}
                  style={{
                    padding: '16px 32px',
                    background: submitSuccess 
                      ? 'linear-gradient(90deg, #10b981 0%, #059669 100%)'
                      : 'linear-gradient(90deg, #00b4a0 0%, #1e90ff 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '10px',
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    cursor: isSubmitting || submitSuccess ? 'not-allowed' : 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(0,180,160,0.3)',
                    marginTop: '10px',
                    opacity: isSubmitting ? 0.7 : 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '12px',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                  onMouseOver={(e) => {
                    if (!isSubmitting && !submitSuccess) {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 6px 20px rgba(0,180,160,0.4)';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!isSubmitting && !submitSuccess) {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = '0 4px 15px rgba(0,180,160,0.3)';
                    }
                  }}
                >
                  {isSubmitting && (
                    <>
                      <div style={{
                        width: '20px',
                        height: '20px',
                        border: '3px solid rgba(255,255,255,0.3)',
                        borderTop: '3px solid white',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                      }} />
                      <style>{`
                        @keyframes spin {
                          0% { transform: rotate(0deg); }
                          100% { transform: rotate(360deg); }
                        }
                      `}</style>
                      <span>Submitting...</span>
                    </>
                  )}
                  {submitSuccess && (
                    <>
                      <div style={{
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        background: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        animation: 'scaleIn 0.3s ease'
                      }}>
                        <span style={{ color: '#10b981', fontSize: '16px', fontWeight: 'bold' }}>✓</span>
                      </div>
                      <style>{`
                        @keyframes scaleIn {
                          0% { transform: scale(0); }
                          50% { transform: scale(1.2); }
                          100% { transform: scale(1); }
                        }
                      `}</style>
                      <span>Message Sent!</span>
                    </>
                  )}
                  {!isSubmitting && !submitSuccess && 'Submit'}
                </button>

                {/* Success Message */}
                {submitSuccess && (
                  <div style={{
                    marginTop: '20px',
                    padding: '16px 20px',
                    background: 'linear-gradient(90deg, rgba(16,185,129,0.1) 0%, rgba(5,150,105,0.1) 100%)',
                    border: '2px solid #10b981',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    animation: 'slideDown 0.4s ease'
                  }}>
                    <style>{`
                      @keyframes slideDown {
                        0% { opacity: 0; transform: translateY(-10px); }
                        100% { opacity: 1; transform: translateY(0); }
                      }
                    `}</style>
                    <div style={{
                      width: '32px',
                      height: '32px',
                      background: '#10b981',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <span style={{ color: 'white', fontSize: '18px', fontWeight: 'bold' }}>✓</span>
                    </div>
                    <div>
                      <h4 style={{ margin: 0, color: '#065f46', fontSize: '1rem', fontWeight: 600 }}>
                        Thank you for reaching out!
                      </h4>
                      <p style={{ margin: '4px 0 0 0', color: '#047857', fontSize: '0.9rem', lineHeight: 1.4 }}>
                        Our experts will contact you within 24 hours.
                      </p>
                    </div>
                  </div>
                )}

                {/* Error Message */}
                {submitError && (
                  <div style={{
                    marginTop: '20px',
                    padding: '16px 20px',
                    background: 'linear-gradient(90deg, rgba(239,68,68,0.1) 0%, rgba(220,38,38,0.1) 100%)',
                    border: '2px solid #ef4444',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    animation: 'slideDown 0.4s ease'
                  }}>
                    <div style={{
                      width: '32px',
                      height: '32px',
                      background: '#ef4444',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <span style={{ color: 'white', fontSize: '18px', fontWeight: 'bold' }}>!</span>
                    </div>
                    <div>
                      <h4 style={{ margin: 0, color: '#991b1b', fontSize: '1rem', fontWeight: 600 }}>
                        Submission Failed
                      </h4>
                      <p style={{ margin: '4px 0 0 0', color: '#dc2626', fontSize: '0.9rem', lineHeight: 1.4 }}>
                        {submitError}
                      </p>
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Why Partner with Us Section */}
      <section style={{ padding: '80px 0', background: 'white' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: 700,
              marginBottom: '15px',
              background: 'linear-gradient(90deg, #00b4a0 0%, #1e90ff 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Why Partner with iValue?
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#64748b', maxWidth: '700px', margin: '0 auto' }}>
              Leverage our expertise to accelerate your data streaming transformation
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '30px',
            maxWidth: '1200px',
            margin: '0 auto'
          }}>
            {[
              {
                icon: '🎓',
                title: 'Certified Experts',
                description: 'Team of Confluent-certified architects and consultants with deep platform expertise'
              },
              {
                icon: '💼',
                title: '50+ Implementations',
                description: 'Proven track record across industries including finance, healthcare, and retail'
              },
              {
                icon: '⏱️',
                title: 'Faster Time-to-Value',
                description: 'Reduce deployment time by 40% with our proven methodologies and frameworks'
              },
              {
                icon: '🔧',
                title: 'End-to-End Services',
                description: 'From strategy to implementation to managed services - we cover it all'
              },
              {
                icon: '📈',
                title: 'Proven ROI',
                description: 'Average 3x improvement in data processing efficiency for our clients'
              },
              {
                icon: '🌐',
                title: 'Global Presence',
                description: '24/7 support across multiple time zones with dedicated account managers'
              }
            ].map((item, index) => (
              <div key={index} style={{
                background: '#f8fafc',
                padding: '35px 25px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '1px solid #e2e8f0',
                transition: 'all 0.3s ease'
              }}>
                <div style={{ fontSize: '3rem', marginBottom: '15px' }}>
                  {item.icon}
                </div>
                <h3 style={{
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  marginBottom: '12px',
                  color: '#1e293b'
                }}>
                  {item.title}
                </h3>
                <p style={{
                  color: '#64748b',
                  lineHeight: 1.6,
                  fontSize: '0.95rem'
                }}>
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;